module.exports = __webpack_public_path__ + "img/global__background-texture.d69f981b.svg";